// extracted by mini-css-extract-plugin
module.exports = {"headline":"ProjectsSettings_headline__3sMPR","counter":"ProjectsSettings_counter__3kgPS"};